// Token management utilities
export const getToken = () => {
  return localStorage.getItem('token');
};

export const setToken = (token) => {
  localStorage.setItem('token', token);
};

export const removeToken = () => {
  localStorage.removeItem('token');
  localStorage.removeItem('tokenExpiresAt');
};

export const isTokenValid = () => {
  const token = getToken();
  const expiresAt = localStorage.getItem('tokenExpiresAt');
  
  if (!token || !expiresAt) {
    return false;
  }
  
  // Check if token has expired using the exact timestamp
  const now = Math.floor(Date.now() / 1000); // Current unix timestamp
  const expiry = parseInt(expiresAt);
  
  return now < expiry;
};

export const getTokenExpirationTime = () => {
  const expiresAt = localStorage.getItem('tokenExpiresAt');
  return expiresAt ? new Date(parseInt(expiresAt) * 1000) : null;
};

export const getTimeUntilExpiry = () => {
  const expiresAt = localStorage.getItem('tokenExpiresAt');
  if (!expiresAt) return 0;
  
  const now = Math.floor(Date.now() / 1000);
  const expiry = parseInt(expiresAt);
  
  return Math.max(0, expiry - now); // Seconds until expiry
}; 